'use strict';

var _ = require('lodash');
var LiteDataService = function LiteDataService(restangular, momentService) {
  var MAX_GET_FILTER_LENGTH = 1500;
  function get(url, request, config) {
    var httpConfig = _.extendWith({
      cache: false
    }, config);
    var headers = {
      'If-Modified-Since': '0'
    }; // to solve AngularJS-caching-issue-for-Internet-Explorer

    if (request && request.filter && request.filter.length > MAX_GET_FILTER_LENGTH) {
      var created = momentService.now(momentService.FIELD.EVENT_TIME_STAMP).toString();
      var payload = {
        filter: request.filter,
        createdAt: created
      };
      return restangular.service('/configured/filter').post(payload).then(function (result) {
        var newRequest = _.extend(_.clone(request), {
          filterId: result._id,
          filter: undefined
        });
        return restangular.one(url).withHttpConfig(httpConfig).get(newRequest, headers);
      })["catch"](function () {
        throw new Error('Cannot post filterId to /configured/filter');
      });
    }
    return restangular.one(url).withHttpConfig(httpConfig).get(request, headers);
  }
  function post(url, payload) {
    return restangular.service(url).post(payload);
  }
  function put(url, payload) {
    return restangular.all(url).customPUT(payload);
  }
  return {
    get: get,
    post: post,
    put: put
  };
};
LiteDataService.$inject = ['Restangular', 'MomentService'];
module.exports = LiteDataService;